/**
 * ROUTE: src/components/Pruebas/pruebas.utils.js
 * Helpers compartidos entre los sub-componentes de Pruebas.
 *
 * NOTA IDs de deporte:
 *   Atletismo → Hayllis: 2  | API externa: 7
 *   Natación  → Hayllis: 11 | API externa: 9
 */

// IDs internos (Hayllis)
export const ATLETISMO_EVENT_ID   = 223;
export const ATLETISMO_SPORT_ID   = 2;   
export const NATACION_SPORT_ID    = 11;


export const EXTERNAL_SPORT_ID_MAP = {
  2:  7, 
  11: 9,  
};

export const toExternalSportId = (idsport) =>
  EXTERNAL_SPORT_ID_MAP[Number(idsport)] ?? Number(idsport);

export const getBadgeColor = (status) => {
  switch (status) {
    case "finalizado": return "bg-green-100 text-green-700";
    case "en_curso":   return "bg-yellow-100 text-yellow-700";
    default:           return "bg-gray-100 text-gray-500";
  }
};

export const capitalize = (str = "") =>
  str.trim().charAt(0).toUpperCase() + str.trim().slice(1).toLowerCase();

export const getMedalColor = (pos) => {
  switch (pos) {
    case 1: return "text-yellow-500 font-bold";
    case 2: return "text-gray-400 font-bold";
    case 3: return "text-amber-600 font-bold";
    default: return "text-gray-500";
  }
};

export const parseCategoryTokens = (name = "") => {
  const upper = name.toUpperCase();

  const genero = upper.includes("DAMAS")
    ? "Damas"
    : upper.includes("VARONES")
    ? "Varones"
    : null;

  const nivel = /\bAZ\b/.test(upper)
    ? "Az"
    : /\bNV\b/.test(upper)
    ? "Nv"
    : null;

  return { genero, nivel };
};